import { Toaster as SonnerToaster } from 'sonner'

export const Toaster = () => {
  return (
    <SonnerToaster
      position="bottom-right"
      closeButton
      toastOptions={{
        unstyled: true,
        classNames: {
          toast:
            'font-sans w-[300px] rounded-lg border border-border pl-4 pr-10 py-4 flex flex-wrap items-center gap-2 text-sm bg-white relative data-[type=success]:text-toast-success-text data-[type=warning]:text-toast-warning-text data-[type=error]:text-toast-error-text data-[type=info]:text-toast-info-text',
          title: 'font-semibold flex-1',
          description: 'font-normal',
          actionButton:
            '!w-full !bg-transparent !border !border-border !text-foreground !rounded-md !px-3 !py-1.5 !text-xs !font-medium hover:!bg-background-secondary !transition-colors !cursor-pointer',
          closeButton:
            '!absolute !right-3 !top-4 !bg-transparent !border-none !text-foreground !shadow-none [&_svg]:!size-[18px]',
        },
      }}
    />
  )
}
